// search result types
export const ALL = "all";
export const NEWS = "news";

// filters
export const SET_ALL = "SET_ALL";
export const SET_NEWS = "SET_NEWS";

export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
